<template>
  <div class="release-navBar">
    <div>
      <div class="add-Btn">
        <b-button v-b-modal.modal-1 class="actionBtn clientShowBtn">Add </b-button>&nbsp;
        <b-button class="actionBtn clientShowBtn" @click="PublishModal = true">Publish
        </b-button>
      </div>

      <b-modal v-model="ReleaseNotesModal" id="modal-1" hide-backdrop centered title="Add Release Notes"
        @cancel="clearValues()" no-close-on-esc no-close-on-backdrop>
        <!-- <b-container> -->
          <b-row class="modalRowContainer">
            <b-col class="requestCol" md="6">
              <b-row>
                <b-col class="reqContent" md="3">
                  <h8>Type</h8>
                </b-col>
                <b-col class="reqContent" md="9">
                  <b-form-group label-for="type-select" >
                    <b-form-select v-model="type" class="m-12" :state="type == '' ? false : true" id="type-select" @blur="validateField('type-select')">
                      <option value="FEATURE" class="text-color-blue">
                        Feature
                      </option>
                      <option value="FIXED" style="color: brown">Fixed</option>
                      <option value="ANNOUNCEMENT">Announcement</option>
                      <option value="CHANGES">Change</option>
                      <option value="CONFIGURATION">Configuration</option>
                      <option value="UPCOMING RELEASE">Upcoming Release</option>
                    </b-form-select>
                  </b-form-group>
                  <span v-if="errors.type" style="color: red">{{ errors.type }}</span>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="reqContent" md="3">
                  <h8>Date</h8>
                </b-col>
                <b-col class="reqContent" md="4">
                  <b-form-group label-for="datePicker">
                  <Datepicker id="datePicker" v-model="value" placeholder="Date" @input="onDateChange()" :clearable=false  @blur="validateField('datePicker')"/>
                </b-form-group>
              </b-col>
              <b-col class="reqContent" md="3">
                  <p v-if="errors.datePicker" style="color: red;">
                    {{ errors.datePicker }}
                  </p>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="reqContent" md="3">
                  <h8>Name</h8>
                </b-col>
                <b-col class="reqContent" md="9" style="display: block;">
                  <b-form-group label-for="textName" >
                    <b-form-textarea class="overflow-auto" id="textName" v-model="name" placeholder="Enter something..."
                      rows="2" max-rows="6" :state="name == '' ? false : true"  @blur="validateField('textName')"></b-form-textarea>
                  </b-form-group>
                  <p v-if="errors.textName" style="color: red">{{ errors.textName }}</p>
                </b-col>
                  
              </b-row>
              <b-row>
                <b-col class="reqContent" md="3">
                  <h8>Description</h8>
                </b-col>
                <b-col class="reqContent" md="9" style="display: block;">
                  <b-form-group label-for="textarea" >
                    <b-form-textarea class="overflow-auto" id="textarea" v-model="description"
                      placeholder="Enter something..." rows="4" max-rows="6"
                      :state="description == '' ? false : true" @blur="validateField('textarea')"></b-form-textarea>
                  </b-form-group>
                  <p v-if="errors.textArea" style="color: red">{{ errors.textArea }}</p>
                </b-col>
                  <b-col class="reqContent" md="9">
                  
                </b-col>
              </b-row>
              <b-row>
                <b-col class="reqContent" md="3">
                  <h8>Release For</h8>
                </b-col>
                <b-col class="reqContent" md="9" v-model="target">
                  <b-form-group v-slot="{ ariaDescribedby }" label-for="some-radios">
                    <b-form-radio :aria-describedby="ariaDescribedby" class="mb-3" name="some-radios"
                      value="_PLATFORM_" v-model="ReleaseSelectedOption">Platform
                    </b-form-radio>
                    <div style="display: flex;">
                    <b-form-radio class="mb-3" name="some-radios" value="tenant" style="padding-top: 10px" v-model="ReleaseSelectedOption">
                      Tenant
                    </b-form-radio>
                    <div class="d-flex align-items-center filterWrapper-modelselect" v-if="ReleaseSelectedOption=='tenant'" >
                   
                        <model-select v-model="tenantObj" :options="tenants" name="text" id="value"
                          placeholder="Select Tenant" @input="validateSelection">
                        </model-select>
                        <!-- <b-form-select id="tenantId" v-model="tenant">
                          <option
                            class="tenantOption"
                            v-for="option in tenants"
                            v-bind:key="option.value"
                            :value="option.value"
                          >
                            {{ option.text ? option.text : option.value }}
                          </option>
                        </b-form-select> -->
                      </div>
                    </div>
                    <div style="display: inline-flex;">
                    <b-form-radio :aria-describedby="ariaDescribedby" name="some-radios" value="version number"
                      style="padding-top: 15px" v-model="ReleaseSelectedOption">
                      Version
                    </b-form-radio>
                    <div class="d-flex align-items-center" style="margin-top: -7px;display: inline;" v-if="ReleaseSelectedOption=='version number'">
                        
                        <input id="version-number" class="ml-3 p-2" style="
                            border: 1px solid #ebebeb !important;
                            margin-top: 9px;
                            border-radius: 5px;
                          " v-model="versionInput" type="text" placeholder="Version" required v-mask="'#.##.##'" />
                      </div>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-row>
                    <b-button style="display: block; margin: 1rem auto" variant="primary"
                      @click.prevent="clearValues">Cancel
                    </b-button>

                    <b-button style="display: block; margin: 1rem auto" variant="primary" :disabled="enableAddButton()"
                      @click.prevent="addReleaseNotes">Add
                    </b-button>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
            <b-col class="previewCol" md="6" style="overflow-y: auto; height: 700px">
              <b-row>
                <h5 style="text-align: center; margin: 1rem">Preview</h5>
              </b-row>
              <div v-for="item in previewData" v-bind:key="item.name" style="margin-top: 10px">
                <b-row>
                  <b-col>
                    <p>{{ item.date }}</p>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div class="previewText">
                      <div>
                        <b-badge>{{ item.type }}</b-badge>
                        <b-button-close @click.prevent="removeRleaseNotesData(item)"></b-button-close>
                      </div>
                      <b-row>
                        <p style="margin-left: 6%; width: fit-content">
                          {{ item.description }}
                        </p>
                      </b-row>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <b-row>
                <b-col>
                  <b-button v-if="previewData.length > 0" style="display: block; margin: 1rem auto" variant="primary"
                    @click.prevent="createNotes">Submit
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        <!-- </b-container> -->
      </b-modal>

      <b-modal v-model="PublishModal" hide-backdrop id="modal-2" centered title="Publish Notes" ok-title="Publish"
        @ok="setEmails" @cancel="clearPublishValues">
        <b-col class="requestCol2" md="12">
          <b-row>
            <b-col class="reqContent" md="12">
              <label>Which</label>
            </b-col>
            <b-col md="12">
              <b-form-group label-for="which" invalid-feedback="Please select a which.">
                <b-form-select v-model="which" :state="which == '' ? false : true" class="m-12" id="which">
                  <option value="Upcoming Release" class="text-color-blue">
                    Upcoming Release
                  </option>
                  <option value="Specific Dates">Specific Dates</option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row v-if="which == 'Specific Dates'">
            <b-col class="reqContent" md="12">
              <label>Date Range</label>
            </b-col>
            <b-col md="12">
              <Datepicker id="date" range v-model="dateRange" range-separator=" - " placeholder="Date Range"
                style="width: 100%" @change="onDateRangeChange()">
              </Datepicker>
              <p v-if="dateRange == ''" style="color: red; margin-left: 10px; margin-top: 10px">
                Enter a valid Date
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="reqContent" md="12">
              <label>Who</label>
            </b-col>
            <b-col md="12">
              <b-form-group label-for="who" invalid-feedback="Please select a who.">
                <b-form-select v-model="who" :state="who == '' ? false : true" class="m-12" id="who" style="width: 100%">
                  <option value="Default" class="text-color-blue">
                    Default
                  </option>
                  <option value="Other">Other</option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="who == 'Other'">
            <b-col class="reqContent" md="12">
              <label>Emails</label>
            </b-col>
            <b-col md="12">
              <b-form-group label-for="textEmail" invalid-feedback="Please enter a email.">
                <b-form-input class="overflow-auto" id="textEmail" type="text" v-model="emails"
                  :state="emails == '' ? false : true" placeholder="Enter Email's"></b-form-input>
              </b-form-group>
            </b-col>
            <p v-if="who == 'Other'">
              *Please seperate the emails by comma(,) or semicolon(;)
            </p>
          </b-row>
        </b-col>
      </b-modal>
    </div>
  </div>
</template>

<script src="https://cdn.jsdelivr.net/npm/vue/dist/vue.min.js"></script>
<script src="https://cdn.jsdelivr.net/npm/v-mask/dist/v-mask.min.js"></script>
<script>
import Datepicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Vue from "vue";
import VueToast from "vue-toast-notification";
import VueMask from "v-mask";
import { ModelSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'


Vue.use(VueMask);
Vue.use(VueToast);
export default {
  name: "ReleaseNavBar",
  components: { Datepicker, ModelSelect },
  data() {
    return {
      dateValue: "",
      value: new Date(),
      text: "",
      tenants: [{ text: "-SELECT-", value: "" }],
      tenantsList: [],
      type: "",
      which: "",
      who: "",
      name: "",
      description: "",
      versionInput: "",
      tenant: "",
      tenantObj: "",
      target: "",
      ReleaseNotesModal: false,
      PublishModal: false,
      previewData: [],
      dateRange: "",
      emails: "",
      submitButtonDiabled: false,
      fromDate: "",
      toDate: "",
      body: {},
      ReleaseSelectedOption:"",
      errors: {
        type: null,
        textName: null,
        textArea: null,
        datePicker:null
      }
    };
  },
  mounted() {
    this.fetchTenants();
  },
  // watch: {
  //   emails: function(newValue) {
  //     const result = newValue.replace(',', ', ')
  //     Vue.nextTick(() => this.emails = result);
  //   }
  // },
  methods: {
    onDateChange() {
      this.dateValue = this.value.format("YYYY-MM-DD");
    },
    validateField(field) {
      if (field === 'type-select') {
        if (!this.type) {
          this.errors.type = 'Please select a type';
        } else {
          this.errors.type = null;
        }
      } else if (field === 'textName') {
       
        if (!this.name) {
          this.errors.textName = 'Please enter a Name';
        
        } else {
          this.errors.textName = null;
        }
      } else if (field === 'textarea') {
        if (!this.description) {
          this.errors.textArea = 'Please enter a description';
        }
        else {
          this.errors.textArea = null;
        }
      }
      else if (field === 'datePicker') {
        if (!this.value) {
          this.errors.datePicker = 'Enter a valid date';
        }
        else {
          this.errors.datePicker = null;
        }
      }
    },
    getDropdownValues(tenant) {
      return this.tenantsList.filter((e) => e.text == tenant || e.value == tenant);
    },
    addReleaseNotes() {
      this.previewData.unshift({
        type: this.type,
        name: this.name,
        date: this.value.format("YYYY-MM-DD"),
        description: this.description,
        target:
          this.target &&
          this.target.target &&
          this.target.target.value == "tenant"
            ? this.tenant
            : this.target && this.target.target && this.target.target.value,
      });
      (this.text = ""),
        (this.type = ""),
        (this.name = ""),
        (this.description = ""),
        (this.tenant = ""),
        (this.versionInput = ""),
        (this.target = "");
    },
    removeRleaseNotesData(item) {
      this.previewData.splice(this.previewData.indexOf(item), 1);
    },
    getTenantId(Obj) {
      let objVal = this.tenants.find(e => e.value == Obj);
      if (objVal) {
        return objVal.id
      }
      else {
        return ""
      }
    },
    validateSelection() {
      this.tenant = this.getTenantId(this.tenantObj);
      this.changeTenantView();
    },
    async fetchTenants() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var tenants_list_request = new Request(
        config.TENET_SERVICE + "/tenants/?list=true",
        {
          method: "GET",
          mode: "cors",
          cache: "default",
          withCredentials: true,
          credentials: "include",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json",
          },
        }
      );
      try {
        var tenants_list = await fetch(tenants_list_request);
        if (tenants_list.status == 503) {
          return this.fetchTenants();
        } else {
          var response = await tenants_list.json();
          this.tenants = response;
          this.tenants = [...this.tenants];
          this.tenants = this.tenants.sort(function (a, b) {
            var nameA = a.text ? a.text.toUpperCase() : ""; // ignore upper and lowercase
            var nameB = b.text ? b.text.toUpperCase() : ""; // ignore upper and lowercase
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          });
          this.tenants.forEach((e) =>
            this.tenantsList.push({ value: e.value, text: e.text || e.value })
          );
        }
      } catch (error) {
        console.error(error);
      }
    },
    dateDisabled(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`) and
      // disable days that fall on the 13th of the month
      const weekday = date.getDay();
      const day = date.getDate();
      // Return `true` if the date should be disabled
      return weekday === 0 || weekday === 6 || day === 13;
    },
    async createNotes(item) {
      this.submitButtonDiabled = true;
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url = config.TENET_SERVICE + "/release-notes";
      var releaseNotes = new Request(url, {
        method: "POST",
        mode: "cors",
        withCredentials: "include",
        credentials: "include",
        cache: "default",
        body: JSON.stringify({
          releaseNotes: this.previewData,
        }),
        headers: {
          Authorization: "Bearer " + id_token,
          "content-type": "application/json",
        },
      });
      try {
        var releaseResponse = await fetch(releaseNotes);
        if (releaseResponse.status == 503) {
          return this.createNotes(item);
        } else {
          this.previewData = [];

          this.submitButtonDiabled = false;
          this.$emit("myEvent", "DATA");

          Vue.$toast.open({
            message: "Release-notes published for approval successfully.",
            type: "success",
          });
        }
      } catch (err) {
        console.log(err);
        Vue.$toast.open({
          message: "Posting of release-notes failed",
          type: "error",
        });
      }
    },
    async setEmails() {
      if (this.which == "") {
        return Vue.$toast.open({
          message: "Please select a which",
          type: "error",
        });
      } else if (this.who == "") {
        return Vue.$toast.open({
          message: "Please select a who",
          type: "error",
        });
      } else if (this.which == "Specific Dates" && this.dateRange == "") {
        return Vue.$toast.open({
          message: "Please enter a date range",
          type: "error",
        });
      } else if (this.who == "Other" && this.emails == "") {
        return Vue.$toast.open({
          message: "Please enter email Id's",
          type: "error",
        });
      }
      const mailIds = this.emails.split(/[,;]/);
      var regexEmail = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      const validMailIds = [];
      mailIds.find((e) => {
        if (regexEmail.test(e)) {
          validMailIds.push(e);
        }
      });
      this.emails = validMailIds.join(",");
      if (this.emails !== "") {
        this.body["emails"] = this.emails;
      }
      if (this.dateRange !== "") {
        this.body["fromDate"] = this.fromDate;
        this.body["toDate"] = this.toDate;
      }

      this.publishNotes();
    },
    async publishNotes() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url = config.TENET_SERVICE + "/release-notes/send-email";
      var releaseNotes = new Request(url, {
        method: "POST",
        mode: "cors",
        withCredentials: "include",
        credentials: "include",
        cache: "default",
        body: JSON.stringify(this.body),
        headers: {
          Authorization: "Bearer " + id_token,
          "content-type": "application/json",
        },
      });
      try {
        var response = await fetch(releaseNotes);
        if (response.status == 503) {
          return this.publishNotes();
        } else {
          this.clearPublishValues();
          Vue.$toast.open({
            message: "Release-notes published successfully.",
            type: "success",
          });
        }
      } catch (err) {
        console.log(err);
        Vue.$toast.open({
          message: "Publishing of release-notes failed",
          type: "error",
        });
      }
    },
    clearPublishValues() {
      (this.emails = ""),
        (this.who = ""),
        (this.which = ""),
        (this.dateRange = "");
    },
    clearValues() {
      (this.name = ""),
      (this.value = new Date()),
        (this.text = ""),
        (this.type = ""),
        (this.description = ""),
        (this.tenant = ""),
        (this.target = ""),
        (this.ReleaseNotesModal = false),
        (this.versionInput = ""),
        (this.dateValue = "");
    },
    onDateRangeChange() {
      this.fromDate = this.dateRange[0].format("YYYY-MM-DD") + "T00:00:00.000Z";
      this.toDate = this.dateRange[1].format("YYYY-MM-DD") + "T00:00:00.000Z";
    },
    enableAddButton() {
      let target =
        this.target && this.target.target && this.target.target.value;
      if (this.tenant != "") {
        target = this.tenant;
      }
      if (
        this.dateValue != "" &&
        this.type != "" &&
        this.name != "" &&
        this.description != "" &&
        target !== ""
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>
<style>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.release-navBar {
  display: flex;
  justify-content: end;
  align-items: center;
  width: 100%;
}

#dropdown-1 {
  margin-right: 50%;
}

.relNav {
  width: 100%;
}

.dropdown:before {
  content: "";
  border: solid #fff;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 2.5px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  position: absolute;
  right: 10px;
  top: 15px;
}

.dropdown-toggle {
  padding: 0 1.5rem !important;
}

.cus-datePicker {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cus-datePicker h5 {
  margin: 0 1rem;
}

.b-calendar-grid-body .btn {
  padding: 0 !important;
}

#modal-1 .modal-header,
#modal-1 .modal-footer {
  display: none !important;
}

#modal-1 .modal-content {
  background-color: unset;
}

.modal-content {
  border: none !important;
}

.requestCol {
  background-color: white;
  padding:0px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.previewCol {
  background-color: white;
}

.requestCol2 {
  background-color: white;
  padding: 0px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.previewCol2 {
  background-color: white;
}

#modal-1 .requestCol,
#modal-1 .previewCol {
  border-radius: 1rem;
  min-height: 50vh;
  border-width: 1px solid black;
}

#modal-2 .requestCol2,
#modal-2 .previewCol2 {
  min-height: 50vh;
}
#modal-2 .requestCol2{
  min-height: auto;
}
.reqContent {
  display: flex;
  /* justify-content: center; */
  align-items: center;
}

.reqContent .dropdown-toggle {
  min-width: 10rem;
}

.requestCol .row {
  margin: 0.5rem 0;
}

/* #input-1 {
    max-width: 50%;
} */

.requestCol .form-group {
  width: 100%;
}

.previewText {
  background-color: aliceblue;
  border-radius: 0.5rem;
  padding: 0.5rem;
}

.previewText .badge {
  background-color: aqua;
}

.btn {
  background: #1dd8f6;
  padding-left: 15px;
  padding-right: 15px;
}

.b-form-btn-label-control {
  height: auto;
}

#datePicker__outer_ label {
  margin-bottom: 0;
  flex: 1;
}

#datePicker__outer_ button {
  padding: 0 15px;
}

#datePicker__outer_ {
  padding: 0;
  border: none;
  flex-direction: row-reverse;
}

.custom-control-label {
  display: flex;
}

#__BVID__20 {
  margin-left: 1px;
}

.actionBtn.clientShowBtn.btn-secondary {
  border-radius: 5px;
  min-width: 80px;
  text-align: center !important;
  display: inline-grid;
  background: #575757;
  color: #fff;
  line-height: 36px;
  padding: 0 15px;
  cursor: pointer;
  font-size: 15px;
  border-color: #575757;
  padding-right: 10px;
}

.actionBtn.clientShowBtn.btn-secondary:hover {
  background: #1dd8f6;
  color: #ffffff;
  border-color: #1dd8f6;
}
.requestCol2 p{
  padding-left: 15px;
}
.filterWrapper-modelselect {
  display: inline-flex;
  border-color: #25a8ca !important;
  width: 360px;
  border-radius: 5px;
  margin-left: 15px;
  

}
.filterWrapper-modelselect .ui.selection.dropdown{
  border:1px solid gray !important;
}

.ui.dropdown>.dropdown.icon:before {
    content: "\F0D7";
    transform: none;
    padding: 0px;
    font-size: 16px;
    right: 5px;
    top: 13px;
    color: #6a6a6a;
}
.filterWrapper-modelselect .ui.selection.dropdown i.dropdown.icon{
  display: block;
}
@media (min-width: 576px) {
  #modal-2 .modal-dialog {
    max-width: 40%;
    margin: 5.35rem auto;
  }
}

@media (min-width: 576px) {
  #modal-1 .modal-dialog {
    max-width: 80%;
    margin: 5.35rem auto;
  }
}
.modalRowContainer{
  border-left: 1px solid #ebebeb;
  border-radius: 15px;
}
</style>
